import utils from './utils';

export default {
  methods: {
    fmtDate(v) {
      return utils.dateNormalDisplay(v);
    },
  },
  computed: {
    currentPath() {
      return this.$route.path;
    },
  },
};
